var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container m-auto my-3",class:{'p-0 m-0': _vm.isExternal}},[_c('PreSurveySwitchLayout',{attrs:{"shortName":_vm.shortName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }